import React, { forwardRef, useImperativeHandle } from 'react';
import { CardCvcElement, useElements } from '@stripe/react-stripe-js';
import * as S from '../stripe-inputs.style';
import type { StripeElementRef } from '../stripe-card-input/stripe-card-input';

type Props = {
  containerId?: string;
  elementId?: string;
  onStripeChange?: (
    field: 'number' | 'expiry' | 'cvc',
    state: { complete: boolean; error: string | null },
  ) => void;
  variant?: 'classic' | 'modern';
  color?: string;
};

export const StripeCvcInput = forwardRef<StripeElementRef, Props>(
  (
    {
      containerId = 'stripe-cvc-container',
      elementId = 'stripe-cvc',
      onStripeChange,
      variant = 'classic',
      color,
    },
    ref,
  ) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const elements = useElements();

    useImperativeHandle(ref, () => ({
      focus() {
        const el = elements?.getElement(CardCvcElement);
        el?.focus();
      },
    }));

    return (
      <S.Content id={containerId}>
        <S.InputWrapper>
          <S.StyledStripeElement
            color={color}
            $focused={isFocused}
            $variant={variant}
          >
            <CardCvcElement
              id={elementId}
              onChange={(e) =>
                onStripeChange?.('cvc', {
                  complete: e.complete,
                  error: e.error?.code ?? null,
                })
              }
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              options={{
                placeholder: '123',
                style: {
                  base: {
                    '::placeholder': {
                      color: '#9ca3af',
                    },
                  },
                  invalid: {
                    color: '#000',
                  },
                },
              }}
            />
          </S.StyledStripeElement>
        </S.InputWrapper>
      </S.Content>
    );
  },
);
